import React from 'react';
import MoveNoNewContract from '../sections/MoveNoNewContract';

export const MoveTerminate: React.FunctionComponent = () => (
  <>
    <MoveNoNewContract />
  </>
);

export default MoveTerminate;
